<template>
    <div class="sidebar sidebar-button">
        <button class="button sidebar__button" @click="toggleMenu()">
            <img :src="require('@/assets/img/menu.svg')" alt="menu">
            <span>Категории товаров</span>
        </button>
        <div class="sidebar__menu" v-if="is_open">
            <div class="sidebar-item">
                <div class="sidebar-item__img">
                    <img :src="require('@/assets/img/electronic.svg')" alt="Электроника">
                </div>
                <span>Электроника</span>
            </div>
            <div class="sidebar-item">
                <div class="sidebar-item__img">
                    <img :src="require('@/assets/img/eco.svg')" alt="Экотовары">
                </div>
                <span>Экотовары</span>
            </div>
            <div class="sidebar-item">
                <div class="sidebar-item__img">
                    <img :src="require('@/assets/img/beauty.svg')" alt="Красота и здоровье">
                </div>
                <span>Красота и здоровье</span>
            </div>
            <div class="sidebar-item">
                <div class="sidebar-item__img">
                    <img :src="require('@/assets/img/homegoods.svg')" alt="Товары для дома">
                </div>
                <span>Товары для дома</span>
            </div>
            <div class="sidebar-item">
                <div class="sidebar-item__img">
                    <img :src="require('@/assets/img/garden.svg')" alt="Сад и огород">
                </div>
                <span>Сад и огород</span>
            </div>
            <div class="sidebar-item">
                <div class="sidebar-item__img">
                    <img :src="require('@/assets/img/watch.svg')" alt="">
                </div>
                <span>Часы</span>
            </div>
            <div class="sidebar-item">
                <div class="sidebar-item__img">
                    <img :src="require('@/assets/img/jeweleries.svg')" alt="Украшения и бижутерия">
                </div>
                <span>Украшения и бижутерия</span>
            </div>
            <router-link :to="'/categories'" tag="div" class="sidebar-item sidebar-item__all">
                <span>Все категории</span>
<!--                <chevron-right-icon size="1x" class="custom-class"></chevron-right-icon>-->
            </router-link>
        </div>
    </div>
</template>

<script>
    import { ChevronRightIcon } from 'vue-feather-icons'

    export default {
        name: "SidebarMainButton",
        components: {
            ChevronRightIcon
        },
        data() {
            return {
                is_open: false,
                menu: [
                    {
                        category_name: '',
                        id: 1,
                        children: []
                    },
                    {
                        category_name: '',
                        id: 1,
                        children: []
                    },
                    {
                        category_name: '',
                        id: 1,
                        children: []
                    },
                    {
                        category_name: '',
                        id: 1,
                        children: []
                    },
                    {
                        category_name: '',
                        id: 1,
                        children: []
                    },
                    {
                        category_name: '',
                        id: 1,
                        children: []
                    },
                    {
                        category_name: '',
                        id: 1,
                        children: []
                    },
                    {
                        category_name: '',
                        id: 1,
                        children: []
                    },
                    {
                        category_name: '',
                        id: 1,
                        children: []
                    },
                    {
                        category_name: '',
                        id: 1,
                        children: []
                    },
                ]
            }
        },
        created() {
            this.$route.name === 'main-page' ? this.is_open = true : '';
        },
        methods: {
            toggleMenu() {
                if(this.$route.path === '/') return;
                return this.is_open = !this.is_open;
            }
        },
        watch: {
            '$route' (to, from) {
                this.$route.name === 'main-page' ? this.is_open = true : this.is_open = false;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "./src/styles/menu.scss";
</style>
